/* Doladowywanie kolejnych stron kolekcji przy przewijaniu (8.09.2026).

   Nie buduje wlasnego pobierania - klika istniejacy przycisk "Pokaz wiecej",
   ktory obsluguje `filters.js`. Dzieki temu jest jedna sciezka ladowania:
   ta sama obsluga bledow, ta sama aktualizacja adresu, to samo zachowanie
   przy wlaczonych filtrach.

   `AUTO_MAX` = `Infinity`, czyli pelny nieskonczony przewij - decyzja
   Patryka z 8.09.2026. Swiadomy koszt: stopka (regulamin, kontakt, dostawa)
   jest osiagalna dopiero po doladowaniu wszystkich stron kolekcji. Gdyby to
   kiedys przeszkadzalo, wystarczy wpisac tu liczbe - reszta kodu jej nie
   zaklada i po jej wyczerpaniu przycisk "Pokaz wiecej" przejmuje robote. */
(function () {
  var AUTO_MAX = Infinity;
  var zrobione = 0;
  var obserwator = null;

  function przycisk() {
    return document.querySelector('.listing [data-load-more]');
  }

  /* `filters.js` znaczy listing klasa `loading` na czas pobierania - bez tego
     sprawdzenia obserwator kliknalby drugi raz, zanim pierwsza strona doszla. */
  function trwaLadowanie() {
    var listing = document.querySelector('.listing');
    return !!listing && listing.classList.contains('loading');
  }

  function podepnij() {
    if (obserwator) {
      obserwator.disconnect();
      obserwator = null;
    }

    var btn = przycisk();
    if (!btn || zrobione >= AUTO_MAX) return;

    obserwator = new IntersectionObserver(function (wpisy) {
      wpisy.forEach(function (wpis) {
        if (!wpis.isIntersecting) return;
        if (trwaLadowanie() || zrobione >= AUTO_MAX) return;
        zrobione += 1;
        btn.click();
        if (zrobione >= AUTO_MAX && obserwator) {
          obserwator.disconnect();
          obserwator = null;
        }
      });
      /* 300 px zapasu: strona zaczyna sie pobierac, zanim przycisk wjedzie
         w kadr, wiec kafle sa juz na miejscu, gdy uzytkownik tam dojedzie. */
    }, { rootMargin: '300px 0px' });

    obserwator.observe(btn);
  }

  /* Zmiana filtrow podmienia caly `[data-listing]`, wiec przycisk bywa nowym
     elementem - obserwator trzeba wtedy podpiac od nowa. */
  function pilnujListingu() {
    var listing = document.querySelector('[data-listing]');
    if (!listing) return;
    var czeka = null;
    new MutationObserver(function () {
      clearTimeout(czeka);
      czeka = setTimeout(podepnij, 100);
    }).observe(listing, { childList: true, subtree: true });
  }

  function start() {
    if (!document.querySelector('.listing')) return;
    podepnij();
    pilnujListingu();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
